const anyValueIsEmpty = (...values) => {
  return values.some(isEmptyString);
};

const isEmptyString = (value) => {
  return !value;
};

export default anyValueIsEmpty;
